export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9390.9bfd6dfc.jpg";